export class Feature{
    id:number
    name:string
    description:string
    active:boolean
    
}